<template>
  <div class="footer">
    <div class="container">
      <div class="webmap clearfix">
        <dl>
          <dt><img src="../assets/images/logo_bak.png" style="width: 123px;"></dt>
          <dd>趣编网是一个集短视频创作、交易、推广运营于一体的平台，服务于视频需求方和视频创作者，致力于打造视频梦工厂。</dd>
        </dl>

        <dl>
          <dt>关于我们</dt>
          <dd><a href="flow.html">服务流程</a></dd>
          <dd><a href="question.html">常见问题</a></dd>
          <dd><a href="about.html">公司介绍</a></dd>
        </dl>

        <dl>
          <dt>&nbsp;</dt>
          <dd><a href="agreement.html">趣编网服务协议</a></dd>
          <dd><a href="policy.html">趣编网隐私政策</a></dd>
        </dl>

        <dl>
          <dt>联系我们</dt>
          <dd>咨询热线&nbsp;&nbsp;0571-86885271</dd>
          <dd>工作时间&nbsp;&nbsp;9:00-18:00&nbsp;&nbsp;(周一至周五)</dd>
          <dd>
            <a id="qvQ2" style="margin-right: 20px;"><i class="qq"></i>客服QQ</a>
            <a href="https://weibo.com/u/6066981669?is_hot=1" target="_blank" rel="nofollow"><i class="blog"></i>新浪微博</a>
          </dd>
        </dl>

        <dl>
          <dd><img src="../assets/images/qr.png" width="100" height="100" alt="趣编官方公众号"/></dd>
          <dd>扫一扫关注官方微信</dd>
        </dl>

        <dl>
          <dd><img src="../assets/images/qr2.jpg" width="100" height="100" alt="趣编官方公众号"/></dd>
          <dd>扫一扫关注小程序</dd>
        </dl>
      </div>

      <div class="clearfix copyright" style="line-height: 25px;">
        <div class="l" style="margin-right: 40px;">
          <p>Copyright © 2017 趣编网 All Rights Reserved <a href="http://beian.miit.gov.cn/" target="_blank">浙ICP备17002490号-1</a></p>
          <p>
            <a target='_blank' @click="togs()" style="opacity: 1;">
              <img src='../assets/images/gs.png' style="display: inline-block; margin-top: -2px; margin-right: 5px; width: 18px; height: 18px; vertical-align: middle;"/>浙江工商网络监管
            </a>
            <a target="_blank" @click="toga()" style="opacity: 1; padding-left:10px;">
              <img src="../assets/images/gonganbeian.png" style="display: inline-block; margin-top: -2px; margin-right: 5px; width: 18px; height: 18px; vertical-align: middle;"/>
              浙公网安备 33010802007761号</a>
          </p>
        </div>

        <div class="l">
          <!-- <a href="https://ss.knet.cn/verifyseal.dll?sn=e18083133010075205ixdh000000&pa=111332" tabindex="-1" id="urlknet" target="_blank">
            <img alt="&#x53EF;&#x4FE1;&#x7F51;&#x7AD9;" name="KNET_seal" border="true" src="../assets/images/ss.png" style="margin-top:3px; width: 120px;" />
          </a> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
      togs() {
        window.open("http://idinfo.zjaic.gov.cn//bscx.do?method=lzxx&id=3301083301080000076287");
      },
      toga(){
        window.open("http://www.beian.gov.cn/portal/registerSystemInfo");
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  a{ color: #ffffff;}
  .footer{ padding-top:60px; font-size: 12px; color: #FFFFFF; background: #232937;}
  .footer .webmap dl{ float: left; margin-left: 40px; font-size: 14px;}
  .footer .webmap dl dt{ margin-bottom: 18px;}
  .footer .webmap dl dt img{ width: auto;}
  .footer .webmap dl dd{ margin-bottom: 9px; opacity: 0.5;}
  .footer .webmap dl:nth-child(1){ margin-left: 0; width: 329px; font-size: 12px; letter-spacing: 1px;}
  .footer .webmap dl:nth-child(2){ margin-left:70px; width: 56px;}
  .footer .webmap dl:nth-child(3){ width: 98px;}
  .footer .webmap dl:nth-child(4){ margin-left: 70px; width: 242px;}
  .footer .webmap dl:nth-child(5){ margin-left: 30px; float: right; width: 108px; font-size: 12px;}
  .footer .webmap dl:nth-child(5) dd:first-child{opacity: 1;}
  .footer .webmap dl:nth-child(6){ float: right; width: 108px; font-size: 12px;}
  .footer .webmap dl:nth-child(6) dd:first-child{opacity: 1;}
  .footer .webmap .qq{ display: inline-block; vertical-align: middle; margin-top: -3px; margin-right: 10px; width: 17px; height: 17px; background: url("../assets/images/foot_qq.png") no-repeat scroll center;}
  .footer .webmap .blog{ display: inline-block; vertical-align: middle; margin-top: -3px; margin-right: 10px; width: 17px; height: 17px; background: url("../assets/images/foot_weibo.png") no-repeat scroll center;}
  .footer .copyright { padding: 26px 0; color: #FFFFFF; font-size: 12px; opacity: .5;}
</style>



// WEBPACK FOOTER //
// Footer.vue?54fde77b